import { render, staticRenderFns } from "./BaseAlertInline.vue?vue&type=template&id=56c89702"
import script from "./BaseAlertInline.vue?vue&type=script&lang=js"
export * from "./BaseAlertInline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports